/* global process */

export default ({ slug, key = '', themeId, entityId, extraParams = {} }) => {
  const templates = {
    'index': '/',
    'product': `/products/${entityId || 1}`,
    'search': '/search',
    '404': '/404',
    'collection': `/collections/${entityId || 1}`,
    'list-collections': '/collections',
    'cart': '/carts/1',
    'accept-invitation': '/customers/invite/accept',
    'activate-account': '/customers/activate_account',
    'edit-password': '/customers/reset_password/edit',
    'login': '/customers/login',
    'register': '/customers/register',
    'reset-password': '/customers/reset_password/new',
    'page': `/pages/${entityId || 'preview-page'}`,
    'privacy-policy': '/privacy-policy'
  }
  const templateTypes = Object.keys(templates)

  const match = key.match(new RegExp(`templates/(${templateTypes.join('|')}).*.(?:json|liquid)`))
  const templateType = match?.[1]

  const base =
    {
      production: `${slug}.booqable.com/shop`,
      development: `${slug}.${process.env.PROXY_HOST || 'booqable.test'}/shop`,
      test: `127.0.0.1:${window.testPort || 4000}`,
      staging: `${slug}.staging.booqable.com/shop`,
      feature: `${window.location.host}/shop`,
      snapshots: `${window.location.host}/shop`
    }[window.booqableOptions?.environment ?? window.environment] || '#'

  const url = new URL(`${location.protocol}//${base}/preview${templates[templateType] || ''}`)

  url.searchParams.append('theme_id', themeId)

  if (templateType === 'page') {
    url.searchParams.append('template_key', key)
  }

  Object.entries(extraParams).forEach(([key, value]) => {
    url.searchParams.append(key, value)
  })

  return url.toString()
}
